webpackJsonp([80510426025050,90394964171624,214638383847921,93111298591350],{

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Chat;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Chat() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "18", height: "18", viewBox: "0 0 18 18" },
	    _react2.default.createElement("path", { d: "M17.74,3.44A4.17,4.17,0,0,0,14.42.29,51.65,51.65,0,0,0,9,0,51.65,51.65,0,0,0,3.58.29,4.22,4.22,0,0,0,.24,3.44,27.36,27.36,0,0,0,0,7.08a26.54,26.54,0,0,0,.24,3.57,4.19,4.19,0,0,0,3.34,3.14c.52.06,1,.09,1.56.13v3.41a.68.68,0,0,0,.38.63,1.1,1.1,0,0,0,.27,0,.59.59,0,0,0,.44-.19L10.06,14c1.45,0,2.9-.11,4.36-.25a4.06,4.06,0,0,0,3.32-3.06A23.71,23.71,0,0,0,18,7.06,24.3,24.3,0,0,0,17.74,3.44Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Chat;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Chat() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "22", height: "14", viewBox: "0 0 22 14" },
	    _react2.default.createElement("path", { d: "M6.25,2.27a1.23,1.23,0,0,1,0,1.81l-3,2.82,3,2.82a1.24,1.24,0,0,1,0,1.82,1.4,1.4,0,0,1-1.91,0l-4-3.76A1.22,1.22,0,0,1,0,6.9,1.26,1.26,0,0,1,.38,6l4-3.75A1.38,1.38,0,0,1,6.25,2.27Zm9.5,0a1.38,1.38,0,0,1,1.91,0l4,3.75A1.26,1.26,0,0,1,22,6.9a1.22,1.22,0,0,1-.38.88l-4,3.76a1.4,1.4,0,0,1-1.91,0,1.24,1.24,0,0,1,0-1.82l3-2.82-3-2.82A1.23,1.23,0,0,1,15.75,2.27ZM9.15,14a1.44,1.44,0,0,1-1.09-1.74L11,1.08a1.52,1.52,0,0,1,1.83-1,1.44,1.44,0,0,1,1.09,1.74L11,12.92A1.52,1.52,0,0,1,9.15,14Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = RealisticPrototypes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Pattern = __webpack_require__(31);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	var _RevealWrapper = __webpack_require__(57);
	
	var _RevealWrapper2 = _interopRequireDefault(_RevealWrapper);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _assets = __webpack_require__(227);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RealisticPrototypes(_ref) {
	  var color = _ref.color;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xs', position: 'topBottom' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        _RevealWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12, alignItems: 'center' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 4 },
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { maxWidth: 769 },
	              _react2.default.createElement(
	                _spacing2.default,
	                { type: 'padding', size: 'l', position: 'bottom' },
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.prototypeFallback, { hasShadow: false }))
	              )
	            ),
	            _react2.default.createElement(
	              _maxWidth2.default,
	              { value: 400 },
	              _react2.default.createElement(_HeadingBlock2.default, {
	                title: 'Create realistic prototypes, without code',
	                copy: _react2.default.createElement(
	                  'span',
	                  null,
	                  'In less than 5 minutes, transform your design mockups into interactive, online prototypes without writing a single line of code.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Simply pull in screens made from Sketch, our design tool, or upload your own images - and add hotspots, interactions and layers as you wish.'
	                )
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 8 },
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { minWidth: 770 },
	              _react2.default.createElement(
	                _MediaMultipleImages2.default,
	                {
	                  fallbackImageSrc: _assets2.default.prototypeFallback.src,
	                  fallbackImageAlt: _assets2.default.prototypeFallback.alt,
	                  fallbackImageMaxWidth: _assets2.default.prototypeFallback.maxWidth
	                },
	                _react2.default.createElement(_Shape2.default, {
	                  width: 306,
	                  height: 296,
	                  type: 'losange',
	                  color: 'lightTeal',
	                  center: false,
	                  position: 'absolute',
	                  bottom: '22%',
	                  left: '30%',
	                  top: 'auto'
	                }),
	                _react2.default.createElement(
	                  _ParallaxWrapper2.default,
	                  { speed: 0 },
	                  _react2.default.createElement(_Pattern2.default, {
	                    type: 'shortRectangle',
	                    top: '52%',
	                    left: '30%',
	                    color: color
	                  })
	                ),
	                _react2.default.createElement(
	                  _ParallaxWrapper2.default,
	                  { speed: 0.8 },
	                  _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.chart, {
	                    borderRadius: 'm',
	                    left: '68%',
	                    maxWidth: 244,
	                    position: 'absolute',
	                    top: '36%'
	                  }))
	                ),
	                _react2.default.createElement(
	                  _ParallaxWrapper2.default,
	                  { speed: 1.2 },
	                  _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.buttons, {
	                    borderRadius: 'm',
	                    left: '24%',
	                    maxWidth: 208,
	                    position: 'absolute',
	                    top: '25%'
	                  }))
	                ),
	                _react2.default.createElement(
	                  _ParallaxWrapper2.default,
	                  { speed: 2 },
	                  _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.iPhone, {
	                    hasShadow: false,
	                    maxWidth: 263,
	                    position: 'absolute',
	                    top: 'auto',
	                    left: '42%',
	                    bottom: '25%'
	                  }))
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	RealisticPrototypes.propTypes = {
	  color: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Stakeholders;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Feature = __webpack_require__(45);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaFeature = __webpack_require__(68);
	
	var _MediaFeature2 = _interopRequireDefault(_MediaFeature);
	
	var _RevealWrapper = __webpack_require__(57);
	
	var _RevealWrapper2 = _interopRequireDefault(_RevealWrapper);
	
	var _Mobile = __webpack_require__(460);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Chat = __webpack_require__(526);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Code = __webpack_require__(528);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _assets = __webpack_require__(227);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Stakeholders(_ref) {
	  var color = _ref.color;
	
	  var gridItemProps = {
	    align: 'center',
	    columnSpan: 12,
	    columnSpanM: 12,
	    columnSpanS: 4
	  };
	  var mediaFeatureProps = _extends({}, _assets2.default.prototype, {
	    backgroundColor: color,
	    patternBottom: '10%',
	    patternLeft: 'auto',
	    patternRight: '38%',
	    patternTop: 'auto'
	  });
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'xl', position: 'top' },
	    _react2.default.createElement(
	      _RevealWrapper2.default,
	      null,
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'l' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'l', sizeM: '0', position: 'bottom' },
	          _react2.default.createElement(_HeadingBlock2.default, {
	            maxWidth: 620,
	            alignContent: 'center',
	            alignM: 'center',
	            title: 'Share and present, anywhere',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'Fast URL sharing and embed codes for your mockups means you can start getting actionable feedback in no time. Quickly share your web and mobile prototypes with those who matter, whether that\'s your developers, clients or stakeholders.'
	            ),
	            justifyContent: 'center',
	            justifyM: 'center',
	            size: 'l'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _MediaFeature2.default,
	        mediaFeatureProps,
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12, alignContent: 'space-around' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            gridItemProps,
	            _react2.default.createElement(
	              _maxWidth2.default,
	              { value: 340 },
	              _react2.default.createElement(_Feature2.default, {
	                type: 'icon',
	                icon: _Chat2.default,
	                backgroundColor: color,
	                fontWeight: 'semibold',
	                copy: 'Create realistic user experiences with our built in interactions for web and mobile devices.',
	                title: 'Add transitions and gestures'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            gridItemProps,
	            _react2.default.createElement(
	              _maxWidth2.default,
	              { value: 340 },
	              _react2.default.createElement(_Feature2.default, {
	                type: 'icon',
	                icon: _Mobile2.default,
	                backgroundColor: color,
	                fontWeight: 'semibold',
	                copy: 'Prototype for desktop, iPhone, iPad, Apple TV, Apple Watch and Android devices. If it has a screen, Marvel supports it.',
	                title: 'Support for every screen'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            gridItemProps,
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'l', sizeM: '0', position: 'bottom' },
	              _react2.default.createElement(
	                _maxWidth2.default,
	                { value: 340 },
	                _react2.default.createElement(_Feature2.default, {
	                  type: 'icon',
	                  icon: _Code2.default,
	                  backgroundColor: color,
	                  fontWeight: 'semibold',
	                  copy: 'Work without worry, present your prototypes without wifi, 3G or any other connectivity.',
	                  title: 'Offline downloads'
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	Stakeholders.propTypes = {
	  color: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = UserTesting;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _UserTestingArtwork = __webpack_require__(466);
	
	var _UserTestingArtwork2 = _interopRequireDefault(_UserTestingArtwork);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _RevealWrapper = __webpack_require__(57);
	
	var _RevealWrapper2 = _interopRequireDefault(_RevealWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserTesting() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'topBottom' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        _RevealWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12 },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 7, alignContent: 'center' },
	            _react2.default.createElement(_UserTestingArtwork2.default, { color: 'lightTeal', patternColor: 'teal' })
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 5, alignContent: 'center' },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              size: 'xs',
	              title: 'Validate ideas with user testing',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'Keep user experience at the forefront of your product with',
	                ' ',
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/user-testing/' },
	                  _react2.default.createElement(
	                    _link2.default,
	                    { type: 'blue' },
	                    'user testing'
	                  )
	                ),
	                ', where you can gain invaluable design feedback on your prototype from your target audience, customers and stakeholders.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Watch how they navigate through your prototype with screen, audio and video recordings.'
	              )
	            })
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Prototyping;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _BorderTop = __webpack_require__(458);
	
	var _BorderTop2 = _interopRequireDefault(_BorderTop);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	var _HeroMedia = __webpack_require__(147);
	
	var _HeroMedia2 = _interopRequireDefault(_HeroMedia);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _RealisticPrototypes = __webpack_require__(665);
	
	var _RealisticPrototypes2 = _interopRequireDefault(_RealisticPrototypes);
	
	var _Stakeholders = __webpack_require__(666);
	
	var _Stakeholders2 = _interopRequireDefault(_Stakeholders);
	
	var _UserTesting = __webpack_require__(667);
	
	var _UserTesting2 = _interopRequireDefault(_UserTesting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_COLOR = 'teal';
	var buttons = [{
	  text: 'Sign up free',
	  link: '/signup/',
	  styles: {
	    shape: 'rounded',
	    size: 'large'
	  }
	}, {
	  text: 'Explore Plans',
	  link: '/pricing/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    kind: 'ghost'
	  }
	}];
	
	function Prototyping() {
	  var prototyping = _metadata2.default.features.prototyping;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: prototyping.title,
	      meta: [{
	        name: 'description',
	        content: prototyping.description
	      }, {
	        name: 'keywords',
	        content: prototyping.keywords
	      }],
	      header: { isLight: true },
	      footer: true
	    },
	    _react2.default.createElement(_HeroMedia2.default, {
	      backgroundColor: PAGE_COLOR,
	      color: 'white',
	      tag: 'h1',
	      headline: 'Never present static designs again, prototypes communicate ideas better',
	      headlineMaxWidth: 1020,
	      name: 'mkt_features_prototyping',
	      type: 'video'
	    }),
	    _react2.default.createElement(_Whitespace2.default, { size: 'l', sizeM: 'xl' }),
	    _react2.default.createElement(_RealisticPrototypes2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(_UserTesting2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(_Whitespace2.default, { size: 'm', sizeM: 'xl' }),
	    _react2.default.createElement(
	      _BorderTop2.default,
	      null,
	      _react2.default.createElement(_Stakeholders2.default, { color: PAGE_COLOR })
	    ),
	    _react2.default.createElement(_CtaDefault2.default, {
	      maxWidth: 480,
	      title: 'Join over 2 million people prototyping with Marvel. Get started for free.',
	      buttons: buttons
	    })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-prototyping-index-js-611bcc348bdf1d1573a9.js